import { render, staticRenderFns } from "./SetDevaluations.vue?vue&type=template&id=f9960232&"
import script from "./SetDevaluations.vue?vue&type=script&lang=js&"
export * from "./SetDevaluations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports